<div class="container-modal">
    <div class="header-modal">
        <h1 class="text-color-primary"><strong>{{ 'contratar.datos-personales.modal-fecha-icorrecta.titulo' | translate }}</strong></h1>
        <button mat-icon-button (click)="cerrarModalGeneric()" class="btn-icon-cerrar">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <hr>
    <div class="body-modal">
        <div id="content-fecha-erronea-modal">
            <p>{{ 'contratar.datos-personales.modal-fecha-icorrecta.contenido' | translate }}</p>
            <div id="fecha-dni">
                <p>{{ 'contratar.datos-personales.modal-fecha-icorrecta.fecha-documento' | translate }} <span>{{ fechaDocumento }}</span></p>
            </div>
            <div id="fecha-poliza">
                <p>{{ 'contratar.datos-personales.modal-fecha-icorrecta.fecha-poliza' | translate }} <span>{{ fechaPoliza }}</span></p>
            </div>
            <button id="aplicar-fecha" (click)="aplicarFechaDNI()">{{ 'contratar.datos-personales.modal-fecha-icorrecta.cambiar-fecha' | translate }}</button>
        </div>
    </div>
</div>